<template>
  <section :class="{'inline-block': true}">
    <button-menu
      v-if="true"
      :text-label="$t('project_report')"
      :icon="'file-excel'"
      :active-tooltip="true"
      :positionTooltip="'is-left'"
      :redirect="null"
      :handle-on-click="() => { generateReport() }"
    />

  </section>
</template>

<script>
import ButtonMenu from './quick-button-menu/components/button-menu.vue'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  components: { ButtonMenu },

  props: {
    openWithButton: { type: Boolean, default: true }
  },

  data() {
    return {
      btnGenerateReport: this.$t('generate_report'),
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      project: 'app/project',
    }),
  },

  methods: {

    async generateReport() {

      this.isLoading = true;

      const params = {
        projectId: this.project.id,
      };

      this.$notify.success('generating_report')

      const { data } = await axios.get(`/api/v2/report/generate_sanea`, { params });
      //si nos llega un reporte hay que descargarlo
      if (data) {

        // Descargamos
        window.open(data.data);

        // Reporte generado
        this.$notify.success('report_generated')

      } else {

        // Error
        this.$notify.error('error_export')

      }

      this.isLoading = false;

    }
  }
}
</script>
